import React, { useEffect, useRef, useState } from 'react';
import usePageTitle from 'src/utils/SetPageTitle';
import { ReactComponent as AccordianIcon } from 'src/Images/icons/common/accordion.svg';
import { ReactComponent as TabIcon } from 'src/Images/icons/common/tab.svg';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { CustomToolTip } from 'src/utils/CustomToolTip';
import TabCreateView from 'src/components/Layout/TabCreateView';
import AccordionCreateView from 'src/components/Layout/AccordionCreateView';
import getColorCode from 'src/utils/GetThemeColor';
import Modal from 'react-bootstrap/Modal';
import 'src/style/layout.css';
import CreateOutwardVehicleTrackingBasicDetails from 'src/components/VehicleTrackingCreate/Outward/CreateOutwardVehicleTrackingBasicDetails';
import AdditionalDetails from 'src/components/VehicleTrackingCreate/Outward/AdditionalDetails';
import VehicleTrackingDuplicacyModal from 'src/components/VehicleTrackingCreate/Outward/VehicleTrackingDuplicacyModal';
import {
  createOutwardVehicleTracking,
  resetVehicleDropdownOptions,
  getAttachedDeliveryForOutwardVehicle,
  getVehicleDetailsForOutward,
  resetVehicleDetails,
  resetDeliveryForBusinessPartner,
  resetDeliveryListForVehicleNumber,
  resetAttachedDeliveryForOutwardVehicle,
  validateAndGetDuplicateObjectsForVehicleTracking,
} from 'src/redux/Actions/VehicleTrackingOutward';
import Breadcrumb from 'src/components/Breadcrumb';
import { useSetBreadcrumbData } from 'src/utils/SetBreadcrumbData';

export default function CreateOutwardVehicleTracking() {
  const navigate = useNavigate();
  usePageTitle('Vehicle Tracking • Record Vehicle Tracking');
  const location = useLocation();
  const dispatch = useDispatch();
  const authReducer = useSelector((state) => state.AuthReducer);
  const themeColor = authReducer?.userData?.tenant?.theme;
  const [toggleView, setToggleView] = useState(true);
  const [disableCreateButton, setDisableCreateButton] = useState(false);
  const [isDuplicacyModalOpen, setIsDuplicacyModalOpen] = useState(false);
  const [mobileNumberError, setMobileNumberError] = useState(false);
  const submitLockRef = useRef(false);

  const tenantOrganisationId = authReducer.userData.organisations?.id;

  const handleToggle = () => {
    setToggleView((prevState) => !prevState);
  };

  // states
  const [formData, setFormData] = useState({
    transporterId: null,
    transporterName: null,
    selectedVehicleOption: null,
    vehicleNumber: null,
    workflowId: null,
    plant: null,
    vehicleTrackingType: '2',
    showDeliveryComponent: false,
    autoLoadCreation: true,
    enableLoadSequence: false,
    driverName: null,
    driverMobileNumber: null,
    driverLicenseNumber: null,
    licenseValidity: null,
    eWayBill: null,
    coa: null,
    containerNumber: null,
    originalInvoice: null,
    weightSlip: null,
    remarks: null,
    pucNumber: null,
    pucStartDate: null,
    pucEndDate: null,
    registrationCertificate: null,
    insuranceNumber: null,
    insuranceStartDate: null,
    insuranceEndDate: null,
    fitnessCertificateNumber: null,
    fitnessCertificateStartDate: null,
    fitnessCertificateEndDate: null,
    capacity: null,
    unitOfMeasurementId: null,
    tankCondition: null,
    informationPanel: null,
    lidCondition: null,
    tyreCondition: null,
    tremCard: null,
    reflectors: null,
    safetyHelmet: null,
    safetyShoes: null,
    safetyHandgloves: null,
    safetyGoggles: null,
  });

  const [selectedDeliveryOrder, setSelectedDeliveryOrder] = useState([]);

  const [transporterSearchTerm, setTransporterSearchTerm] = useState('');
  const [vehicleSearchTerm, setVehicleSearchTerm] = useState('');

  const [errorField, setErrorField] = useState(false);

  const [selectedBusinessPartner, setSelectedBusinessPartner] = useState(null);

  const VehicleTrackingOutwardReducer = useSelector(
    (state) => state.VehicleTrackingOutwardReducer,
  );

  const { attachedDeliveryForOutwardVehicle, vehicleDetailsForOutward } =
    VehicleTrackingOutwardReducer;

  // functions

  function handleFormKeyDown(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  }
  function handleOnChange(e) {
    const {
      name,
      type,
      checked,
      transporterName,
      vehicleNumber,
      isCreateOption,
    } = e.target;
    let { value } = e.target;

    if (name === 'driverMobileNumber') {
      value = value.replace(/\D/g, '').slice(0, 10);
      setMobileNumberError(value.length > 0 && value.length !== 10);
    }

    if (name === 'driverLicenseNumber') {
      value = value.replace(/[^a-zA-Z0-9]/g, '');
    }

    if (name === 'vehicleTrackingType' && value === '1') {
      navigate('/vehicle-tracking/create');
    }
    setFormData((prev) => {
      if (
        name === 'transporterId' &&
        prev.transporterId === value &&
        prev.transporterName === transporterName
      ) {
        return prev;
      }

      const updatedData = {
        ...prev,
        [name]: type === 'checkbox' ? checked : value,
      };
      if (name === 'transporterId') {
        updatedData.transporterName = transporterName;
      }
      if (name === 'transporterId' && !isCreateOption) {
        updatedData.selectedVehicleOption = null;
        updatedData.vehicleNumber = null;

        // Also clear prefilled vehicle-related details
        updatedData.registrationCertificate = null;
        updatedData.pucNumber = null;
        updatedData.pucStartDate = null;
        updatedData.pucEndDate = null;
        updatedData.insuranceNumber = null;
        updatedData.insuranceStartDate = null;
        updatedData.insuranceEndDate = null;
        updatedData.fitnessCertificateNumber = null;
        updatedData.fitnessCertificateStartDate = null;
        updatedData.fitnessCertificateEndDate = null;
        updatedData.showDeliveryComponent = false;

        // make sure to reset the selectedDelivery
        setSelectedDeliveryOrder([]);
        dispatch(resetVehicleDropdownOptions());
      }
      if (name === 'selectedVehicleOption') {
        updatedData.vehicleNumber = vehicleNumber;
      }
      return updatedData;
    });
  }

  const handleDeleteDeliveryOrder = (deliveryId) => {
    setSelectedDeliveryOrder((prev) =>
      prev.filter((item) => item.delivery_id !== deliveryId),
    );
  };

  useEffect(() => {
    if (
      formData?.showDeliveryComponent === false &&
      selectedDeliveryOrder?.length > 0
    ) {
      setSelectedDeliveryOrder([]);
    }
  }, [formData?.showDeliveryComponent, selectedDeliveryOrder]);

  function handleCreateOrExistingTransporterAndVehicle() {
    const payload = {};

    // === Transporter ===
    if (formData?.transporterId) {
      // old transporter
      payload.transporter_id = formData.transporterId;
    } else {
      // new transporter
      payload.transporter_extra_data = formData.transporterName;
    }

    // === Vehicle ===
    if (formData?.selectedVehicleOption?.value) {
      // old vehicle with old transporter
      payload.vehicle_id = formData.selectedVehicleOption?.value;
    } else {
      // new vehicle with new transporter
      payload.vehicle_number = formData.vehicleNumber;
    }

    return payload;
  }

  function triggerCreateOutwardApi() {
    const transporterVehiclePayload =
      handleCreateOrExistingTransporterAndVehicle();

    const createGateEntryPayload = {
      tenant_organisation_id: tenantOrganisationId,
      driver_name: formData.driverName,

      ...transporterVehiclePayload,

      is_load_sequence_enabled: formData?.enableLoadSequence,
      driving_license_number: formData.driverLicenseNumber,
      driver_mobile_number: formData.driverMobileNumber,
      safety_helmet: formData.safetyHelmet ?? false,
      safety_shoes: formData.safetyShoes ?? false,
      trem_card: formData.tremCard ?? false,
      safety_handgloves: formData.safetyHandgloves ?? false,
      safety_goggles: formData.safetyGoggles ?? false,
      driver_license_validity: formData.licenseValidity,
      puc_validity_end_date: formData?.pucEndDate,
      puc_validity_start_date: formData?.pucStartDate,
      container_number: formData.containerNumber,
      tank_condition: formData.tankCondition,
      information_panel: formData.informationPanel,
      tyre_condition: formData.tyreCondition,
      lid_condition: formData.lidCondition,
      reflectors: formData.reflectors ?? false,
      test_report: formData.coa,
      weight_slip: formData.weightSlip,
      remarks: formData.remarks,
      registration_certificate: formData?.registrationCertificate,
      puc_number: formData?.pucNumber,
      insurance_number: formData?.insuranceNumber,
      insurance_start_date: formData?.insuranceStartDate,
      insurance_end_date: formData?.insuranceEndDate,
      fitness_certificate_number: formData?.fitnessCertificateNumber,
      fitness_certificate_start_date: formData?.fitnessCertificateStartDate,
      fitness_certificate_end_date: formData?.fitnessCertificateEndDate,
      workflow_id: formData.workflowId,
      plant_id: formData?.plant,
      capacity: formData?.capacity,
      unit_of_measurement_id: formData?.unitOfMeasurementId,
      is_delivery_attached:
        formData?.showDeliveryComponent && selectedDeliveryOrder?.length > 0,
      is_auto_load_creation_enabled: formData?.autoLoadCreation ?? true,
      delivery_id: selectedDeliveryOrder?.map((item) => item.delivery_id) || [],
      direction: formData.vehicleTrackingType,
    };

    dispatch(createOutwardVehicleTracking(createGateEntryPayload))
      .then((data) => {
        const { vehicleTrackingNumber, workflowStageId } = data || {};
        if (vehicleTrackingNumber && workflowStageId) {
          navigate(`/${workflowStageId}/${vehicleTrackingNumber}`);
        } else {
          navigate('/stations/');
        }
      })
      .finally(() => {
        submitLockRef.current = false;
        setDisableCreateButton(false);
      });
  }

  function handleCreateOutward() {
    if (submitLockRef.current) return;
    submitLockRef.current = true;
    setDisableCreateButton(true);

    const isTransporterValid =
      formData?.transporterId || formData?.transporterName;

    const isVehicleValid =
      formData?.selectedVehicleOption &&
      (formData.selectedVehicleOption.value || formData?.vehicleNumber);
    const isMobileNumberValid =
      !formData?.driverMobileNumber ||
      formData.driverMobileNumber.length === 10;

    const isValidRecord =
      isTransporterValid && isVehicleValid && isMobileNumberValid;

    if (!isValidRecord) {
      setErrorField(true);
      setMobileNumberError(!isMobileNumberValid);
      submitLockRef.current = false;
      setDisableCreateButton(false);
      return;
    }
    setErrorField(false);

    dispatch(
      validateAndGetDuplicateObjectsForVehicleTracking({
        tenant_organisation_id: tenantOrganisationId,
        vehicle_number: formData.vehicleNumber,
      }),
    )
      .then((response) => {
        if (response?.vehicleTrackingDataValidity) {
          // No duplicate found — proceed to create
          triggerCreateOutwardApi();
        } else {
          // Duplicate found — show modal
          submitLockRef.current = false;
          setDisableCreateButton(false);
          setIsDuplicacyModalOpen(true);
        }
      })
      .catch(() => {
        // If validation API fails, fall through to allow creation
        submitLockRef.current = false;
        setDisableCreateButton(false);
      });
  }

  function handleDuplicacyModalBack() {
    setIsDuplicacyModalOpen(false);
  }

  function handleDuplicacyOverrideProceed() {
    if (submitLockRef.current) return;
    submitLockRef.current = true;
    setIsDuplicacyModalOpen(false);
    setDisableCreateButton(true);
    triggerCreateOutwardApi();
  }
  const todayDate = new Date().toISOString().split('T')[0];

  useEffect(() => {
    if (formData?.selectedVehicleOption?.value) {
      dispatch(
        getAttachedDeliveryForOutwardVehicle(
          tenantOrganisationId,
          formData?.selectedVehicleOption?.value,
          todayDate,
        ),
      );
    }
  }, []);

  useEffect(() => {
    if (formData?.selectedVehicleOption?.value) {
      dispatch(
        getVehicleDetailsForOutward(
          tenantOrganisationId,
          formData?.selectedVehicleOption?.value,
        ),
      );
    } else {
      const resetData = {
        registrationCertificate: null,
        pucNumber: null,
        pucStartDate: null,
        pucEndDate: null,
        insuranceNumber: null,
        insuranceStartDate: null,
        insuranceEndDate: null,
        fitnessCertificateNumber: null,
        fitnessCertificateStartDate: null,
        fitnessCertificateEndDate: null,
        showDeliveryComponent: false,
      };

      setFormData((prev) => ({
        ...prev,
        ...resetData,
      }));
      dispatch(resetVehicleDetails());
    }
  }, [formData?.selectedVehicleOption?.value]);

  useEffect(() => {
    if (
      vehicleDetailsForOutward &&
      Object.keys(vehicleDetailsForOutward).length > 0 &&
      formData?.selectedVehicleOption?.value
    ) {
      const prefillData = {
        registrationCertificate:
          vehicleDetailsForOutward?.registrationCertificate,
        pucNumber: vehicleDetailsForOutward?.pucNumber,
        pucStartDate: vehicleDetailsForOutward?.pucValidityStartDate,
        pucEndDate: vehicleDetailsForOutward?.pucValidityEndDate,
        insuranceNumber: vehicleDetailsForOutward?.insuranceNumber,
        insuranceStartDate: vehicleDetailsForOutward?.insuranceStartDate,
        insuranceEndDate: vehicleDetailsForOutward?.insuranceEndDate,
        fitnessCertificateNumber:
          vehicleDetailsForOutward?.fitnessCertificateNumber,
        fitnessCertificateStartDate:
          vehicleDetailsForOutward?.fitnessCertificateStartDate,
        fitnessCertificateEndDate:
          vehicleDetailsForOutward?.fitnessCertificateEndDate,
      };

      setFormData((prev) => ({
        ...prev,
        ...prefillData,
      }));
    }
  }, [vehicleDetailsForOutward]);

  useEffect(() => {
    if (
      attachedDeliveryForOutwardVehicle?.length > 0 &&
      formData?.showDeliveryComponent
    ) {
      setSelectedDeliveryOrder(attachedDeliveryForOutwardVehicle);
    }
  }, [attachedDeliveryForOutwardVehicle, formData?.showDeliveryComponent]);

  const createVehicleTrackingComponents = [
    {
      id: 1,
      title: 'Basic Details',
      component: (
        <CreateOutwardVehicleTrackingBasicDetails
          formData={formData}
          selectedDeliveryOrder={selectedDeliveryOrder}
          setSelectedDeliveryOrder={setSelectedDeliveryOrder}
          handleOnChange={(e) => handleOnChange(e)}
          setFormData={setFormData}
          transporterSearchTerm={transporterSearchTerm}
          setTransporterSearchTerm={setTransporterSearchTerm}
          vehicleSearchTerm={vehicleSearchTerm}
          setVehicleSearchTerm={setVehicleSearchTerm}
          errorField={errorField}
          handleDeleteDeliveryOrder={handleDeleteDeliveryOrder}
          selectedBusinessPartner={selectedBusinessPartner}
          setSelectedBusinessPartner={setSelectedBusinessPartner}
        />
      ),
    },
    {
      id: 2,
      title: 'Additional Details',
      component: (
        <AdditionalDetails
          formData={formData}
          handleOnChange={(e) => handleOnChange(e)}
          mobileNumberError={mobileNumberError}
        />
      ),
    },
  ];

  useSetBreadcrumbData(location.pathname, 'Record Vehicle');

  useEffect(
    () => () => {
      setSelectedDeliveryOrder([]);
      dispatch(resetDeliveryForBusinessPartner());
      dispatch(resetDeliveryListForVehicleNumber());
      dispatch(resetAttachedDeliveryForOutwardVehicle());
    },
    [],
  );

  return (
    <form
      className="page-layout div-flex-column"
      onSubmit={(e) => e.preventDefault()}
      onKeyDown={handleFormKeyDown}
    >
      <Modal
        show={isDuplicacyModalOpen}
        onHide={() => handleDuplicacyModalBack()}
        centered
        backdrop="static"
        keyboard={false}
        size="lg"
        dialogClassName="vt-duplicacy-modal-dialog"
      >
        <Modal.Body className="p-0">
          <VehicleTrackingDuplicacyModal
            duplicateData={
              VehicleTrackingOutwardReducer.validateAndGetDuplicateObjectsForVehicleTracking
            }
            onBack={() => handleDuplicacyModalBack()}
            onProceed={() => handleDuplicacyOverrideProceed()}
            isProceeding={disableCreateButton}
            themeColor={themeColor}
            attemptedVehicleNumber={formData.vehicleNumber}
          />
        </Modal.Body>
      </Modal>
      <div className="div-flex-column">
        <div className="form-header-container div-flex-row div-space-between border-bottom div-align-center">
          <div className="div-flex-column rg-5">
            <div className="div-flex-row left-padding cg-5">
              <Breadcrumb />
            </div>
            <div className="div-space-between slider-padding px-3">
              <span className="text-xxl text-bold">Record Vehicle</span>
            </div>
          </div>
          <div className="div-flex-row toggle-button-container">
            <CustomToolTip title="Tab view" placement="bottom">
              <button
                className={`toggle-button ${toggleView ? `theme-background-${themeColor} icon-color` : null}`}
                onClick={handleToggle}
                type="button"
                aria-label="Toggle tab view"
              >
                <TabIcon
                  className="icon-size-lg"
                  color={getColorCode(themeColor)}
                />
              </button>
            </CustomToolTip>
            <CustomToolTip title="Collapsible view" placement="bottom">
              <button
                className={`toggle-button ${toggleView ? null : `theme-background-${themeColor} icon-color`}`}
                onClick={handleToggle}
                type="button"
                aria-label="Toggle collapsible view"
              >
                <AccordianIcon
                  className="icon-size-lg"
                  color={getColorCode(themeColor)}
                />
              </button>
            </CustomToolTip>
          </div>
        </div>
        <div
          className={`theme-scrollable-container-${themeColor} div-flex-column form-tab-container div-space-between`}
        >
          {toggleView ? (
            <TabCreateView
              createLeadFormComponents={createVehicleTrackingComponents}
            />
          ) : (
            <AccordionCreateView
              createLeadFormComponents={createVehicleTrackingComponents}
            />
          )}
          <div className="div-space-between footer-content-for-page">
            <button
              type="button"
              className={`common-btn-outlined theme-border-color-${themeColor}`}
            >
              Cancel
            </button>
            <div className="div-flex-row cg-20">
              <button
                className={`common-btn theme-background-${themeColor}`}
                type="button"
                onClick={handleCreateOutward}
                disabled={disableCreateButton}
              >
                {disableCreateButton
                  ? 'Creating...'
                  : 'Create Vehicle Tracking'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}
